import { useTranslation } from 'react-i18next';
import { PageLoader } from '@app/components/PageLoader';
import PreContractualAgreements from '@modules/borrower/components/loanApplication/PreContractualAgreements';
import CalculatedResultsList from '@modules/calculator/components/CalculatedResultsList';
import RangeSelect from '@modules/calculator/components/RangeSelect';
import RangeSelectAmount from '@modules/calculator/components/RangeSelectAmount';
import useCalculator from '@modules/calculator/hooks/useCalculator';
import getDemoExampleText from '@modules/calculator/utils/getDemoExampleText';
const LoanCalculator = ({ isDemo = false, setIsValidCalculator, onAmountChange, onPeriodChange, startAmount, startPeriod, useOfferingQuery, useCalculationsQuery, }) => {
    const { t } = useTranslation();
    const { isLoading, loanAmount, period, minMaxPeriod, minMaxAmount, setLoanAmount, setPeriod, isPeriodValid, errors, setErrors, isCalculationsLoading, calculationsData, } = useCalculator({
        setIsValidCalculator,
        startAmount,
        startPeriod,
        onAmountChange,
        onPeriodChange,
        useOfferingQuery,
        useCalculationsQuery,
    });
    const handleAmountChange = (amount) => {
        setLoanAmount(amount);
    };
    const handlePeriodChange = (loanPeriod) => {
        setPeriod(loanPeriod);
    };
    if (isLoading) {
        return <PageLoader />;
    }
    return (<div className="flex flex-col gap-6">
            {isDemo && <div className="body-l">{t('financing.demo_calculator_informative_purpose')}</div>}
            <div className="flex flex-row flex-wrap items-start gap-6">
                <div className="flex flex-col gap-6 grow basis-[280px]">
                    <RangeSelectAmount title={t('financing.demo_calculator_loan_amount')} min={Number(minMaxAmount.min)} max={Number(minMaxAmount.max)} onSelect={handleAmountChange} loanAmount={loanAmount} errors={errors} setErrors={setErrors}/>
                    <RangeSelect title={t('financing.demo_calculator_period_in_months')} min={minMaxPeriod.min} max={minMaxPeriod.max} onSelect={handlePeriodChange} loanPeriod={period} loanAmount={loanAmount} isPeriodValid={isPeriodValid} errors={errors} setErrors={setErrors}/>
                </div>
                <CalculatedResultsList isDemo={isDemo} isCalculationsLoading={isCalculationsLoading} calculationsData={calculationsData} exampleText={isDemo && calculationsData
            ? getDemoExampleText(t, loanAmount, period, calculationsData)
            : undefined}/>
            </div>

            {!isDemo && <PreContractualAgreements period={period} amount={loanAmount}/>}
        </div>);
};
export default LoanCalculator;
